import { Activity, LineChart, HeartPulse, Stethoscope, FileBarChart, AlertTriangle, BookOpen } from "lucide-react";

const FEATURES = [
  { icon: Activity, t: "Daily Pain Tracking", d: "Interactive body map with 0–10 intensity per region. Hours scanned, patients seen and exam types logged in under a minute." },
  { icon: LineChart, t: "Injury Trend Monitoring", d: "Personal and clinic-wide trends with rolling weekly, monthly and quarterly views." },
  { icon: HeartPulse, t: "Stretching Library", d: "Curated mobility, strengthening and recovery protocols organized by region and severity." },
  { icon: Stethoscope, t: "Ergonomic Education", d: "Position-by-position guidance: probe grip, bed height, monitor placement, and posture." },
  { icon: FileBarChart, t: "Clinic Analytics", d: "Anonymized aggregate dashboards for managers. Participation, hotspots, compliance and ROI." },
  { icon: AlertTriangle, t: "Risk Identification", d: "Early-warning flags when score velocity exceeds thresholds, with recommended interventions." },
  { icon: BookOpen, t: "Wellness Reporting", d: "Monthly PDF/CSV reports for occupational health teams and university research partnerships." },
];

export default function Features() {
  return (
    <div className="container-x py-20">
      <div className="max-w-2xl">
        <span className="pill">Features</span>
        <h1 className="mt-4 text-4xl sm:text-5xl font-black tracking-tight">Built for clinicians. Loved by clinics.</h1>
        <p className="mt-5 text-lg text-zinc-600">Everything you need to make injury prevention a daily habit—and prove the outcomes.</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
        {FEATURES.map(({ icon: Icon, t, d }) => (
          <div key={t} className="card-marketing" data-testid={`features-${t.toLowerCase().replace(/\s/g,'-')}`}>
            <span className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ background: "var(--gold-light)" }}>
              <Icon className="w-6 h-6" style={{ color: "var(--gold-hover)" }} />
            </span>
            <h3 className="mt-5 font-bold text-xl">{t}</h3>
            <p className="mt-2 text-zinc-600 text-sm leading-relaxed">{d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
